<div class="dropdown mr-4" aria-haspopup="true">
    <div class="topbar-item" data-toggle="dropdown" data-offset="10px,0px" aria-expanded="false"
        (click)="notification_section = true" id="topbarAlignment">
        <div [class]="customStyle" pTooltip="{{'Notifications' | localize}}" tooltipPosition="bottom">
            <i class="flaticon-alarm unread-notification" *ngIf="unreadNotificationCount"></i>
            <span class="label label-danger unread-notification-count" *ngIf="unreadNotificationCount">
                <small>
                    {{unreadNotificationCount}}
                </small>
            </span>
            <i class="flaticon-alarm" *ngIf="!unreadNotificationCount"></i>
        </div>
    </div>

</div>


<p-sidebar  [(visible)]="notification_section" position="right" styleClass="p-sidebar-md p-sidebar-bottom overflow-auto"
    appendTo="body" (onShow)="onPSidebarShow()" (onHide)="onPSidebarHide()">
    <div (scroll)="stopPropogation($event)">
        <div class="pt-4 ml-3">
            <button type="button" class="close text-danger fs-2" (click)="notification_section = false" aria-label="Close"
               >
               <i aria-hidden="true" class="ki ki-close"></i>
            </button>
            <h4 class="font-weight-boldest">
                {{'Notifications' | localize}}
                <span *ngIf="unreadNotificationCount" class="text-primary cursor-pointer"
                    style="font-size: 11px; margin-left: 32px;"
                    (click)="setAllNotificationsAsRead(); $event.preventDefault(); $event.stopPropagation();">{{'Markallasread'|
                    localize}}</span>
            </h4>
        </div>
        <hr/>
        <div class="px-0 pb-0">
            <div class="max-height" (click)="loadNotifications()" (scroll)='scrollEvent($event)'>
                <div class="bg-gray-2  px-4" *ngIf="getTodaysNotifications(notifications)?.length">
                    {{'Today' | localize}}
                </div>
                <div class="row">
                    <div class="col-12 py-5" [ngClass]="{'bg-primary-o-15':  notification.state != 'READ' }"
                        *ngFor="let notification of getTodaysNotifications(notifications)"
                        (click)="setNotificationAsRead(notification); $event.preventDefault(); $event.stopPropagation();">
                        <div class="row no-gutters" (click)="gotoUrl(notification.url)">
                            <div class="col-2 text-center p-3">
                                <img *ngIf="getNotificationImage(notification)"
                                    src="{{ getNotificationImage(notification) }}"
                                    class="img-fluid border border-light rounded p-1 w-60px h-60px" id="profimgsize" />
                                <div class="mr-4"><i *ngIf="!getNotificationImage(notification)"
                                        class="{{notification.icon}} {{notification.iconFontClass}} icon-xxl"></i></div>
                            </div>
                            <div class="col-6">
                                <div>
                                    <span class="text-muted font-size-sm"
                                        pTooltip=" {{ getNotificationText(notification) }}" tooltipPosition="bottom">
                                        {{ getNotificationText(notification)? ( getNotificationText(notification) |
                                        slice:0:68 ) + ( getNotificationText(notification).length > 68 ?'...' : ''):
                                        ' '}}

                                    </span>
                                </div>
                                <div class="mt-2" *ngIf="getNotificationModule(notification)">
                                    <span class="label label-light-info label-pill label-inline mr-2 mt-4"
                                        style="cursor: pointer;" *ngIf="getNotificationModule(notification)"
                                        (click)="goToModule(notification)">{{ getNotificationModule(notification)
                                        }}</span>
                                </div>
                            </div>
                            <div class="col-4 d-flex justify-content-end py-2">
                                <span class="text-muted pr-4">
                                    {{notification.creationTime | luxonFromNow}}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="bg-gray-2  px-4 py-3 "
                    *ngIf="getEarlierNotifications(notifications) && getEarlierNotifications(notifications).length">
                    {{'EARLIER' | localize}}
                </div>
                <div class="row">
                    <div class="col-12 py-5" *ngFor="let notification of getEarlierNotifications(notifications)"
                        (click)="setNotificationAsRead(notification); $event.preventDefault(); $event.stopPropagation();"
                        [ngClass]="{'bg-primary-o-15':notification.state !== 'READ'}">
                        <div class="row no-gutters" (click)="gotoUrl(notification.url)">
                            <div class="col-2 text-center p-3">
                                <img *ngIf="getNotificationImage(notification)"
                                    src="{{ getNotificationImage(notification) }}"
                                    class="img-fluid rounded w-60px h-60px" />
                                <div class="mr-4"><i *ngIf="!getNotificationImage(notification)"
                                        class="{{notification.icon}} {{notification.iconFontClass}} icon-xxl"></i></div>
                            </div>
                            <div class="col-6">
                                <div class="">
                                </div>
                                <div>
                                    <span class="text-muted font-size-sm"
                                        pTooltip=" {{ getNotificationText(notification) }}" tooltipPosition="bottom">
                                        {{ getNotificationText(notification)? ( getNotificationText(notification) |
                                        slice:0:68 ) + ( getNotificationText(notification).length > 68 ?'...' : ''):
                                        ' '}}

                                    </span>
                                </div>
                                <div class="mt-2">
                                    <span class="label label-light-info label-pill label-inline mr-2 mt-4"
                                        style="cursor: pointer;" *ngIf="getNotificationModule(notification)"
                                        (click)="goToModule(notification)">{{ getNotificationModule(notification) |
                                        localize}}</span>
                                </div>
                            </div>
                            <div class="col-4 d-flex justify-content-end py-2">
                                <span class="text-muted pr-4">
                                    {{notification.creationTime | luxonFromNow | localize}}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div *ngIf="dataLoading">
                    <div class="row mx-2 my-3">
                        <div class="col col-auto pr-0 pl-2">
                            <ngx-shimmer-loading [shape]="'circle'" [width]="'45px'"></ngx-shimmer-loading>
                        </div>
                        <div class="col col-auto d-flex flex-column align-items-start justify-content-center">
                            <ngx-shimmer-loading [width]="'90px'" [height]="'8px'"></ngx-shimmer-loading>
                            <ngx-shimmer-loading [width]="'50px'" [height]="'8px'"></ngx-shimmer-loading>
                        </div>
                    </div>
                    <div class="row mx-2 my-3">
                        <div class="col col-auto pr-0 pl-2">
                            <ngx-shimmer-loading [shape]="'circle'" [width]="'45px'"></ngx-shimmer-loading>
                        </div>
                        <div class="col col-auto d-flex flex-column align-items-start justify-content-center">
                            <ngx-shimmer-loading [width]="'90px'" [height]="'8px'"></ngx-shimmer-loading>
                            <ngx-shimmer-loading [width]="'50px'" [height]="'8px'"></ngx-shimmer-loading>
                        </div>
                    </div>
                    <div class="row mx-2 my-3">
                        <div class="col col-auto pr-0 pl-2">
                            <ngx-shimmer-loading [shape]="'circle'" [width]="'45px'"></ngx-shimmer-loading>
                        </div>
                        <div class="col col-auto d-flex flex-column align-items-start justify-content-center">
                            <ngx-shimmer-loading [width]="'90px'" [height]="'8px'"></ngx-shimmer-loading>
                            <ngx-shimmer-loading [width]="'50px'" [height]="'8px'"></ngx-shimmer-loading>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</p-sidebar>
